import React, { useEffect, useState } from "react";
import "../Style/Component/Customerreviews.css";
import Reviewcard from "./Reviewcard";
import { useSelector } from "react-redux";
import { getWithTokenAPI } from "../Util/Api.js";

const CustomerReviews = () => {
  const auth = useSelector((state) => state.auth);
  const token = auth.token;
  const state = useSelector((state) => state);
  const [review, setReviews] = useState([]);

  const fetchReviews = async () => {
    try {
      const response = await getWithTokenAPI(token, `/feedback/list`);
      setReviews(response?.data || []);
    } catch {
      console.log("Error in fetching reviews");
    }
  };

  useEffect(() => {
    fetchReviews();
  }, [token]);
  return (
    <div className="customerreview">
      <div className="reviewlist">
        {review.map((item, index) => (
          <Reviewcard key={index} review={item} onReplySuccess={fetchReviews} />
        ))}
      </div>
    </div>
  );
};

export default CustomerReviews;
